<template>
  <div>
    <Header></Header>
    <div class='banner-about'><img src='../assets/img/abuout/banner.jpg' alt=''></div>
    <div class='content'>
      <div class='map'>
<!--        <div id='allmap'></div>-->
                        <iframe src='//www.sharkpark.cn/shark/displayMap' frameborder='0' width='80%' height='600'></iframe>
      </div>
      <div>
        <p>【鲨鱼公园地址】</p>
        <p>北京市朝阳区东三环国贸桥西南角 建外SOHO 东区1号楼801</p>

        <p>【首都机场 ➡ 鲨鱼公园乘车路线】</p>
        <p>1.北京首都国际机场乘坐机场大巴方庄线，国贸站下车，南行500米。</p>

        <p>2. 乘坐地铁机场线（东直门方向）到地铁三元桥站下车，换乘地铁10号线到国贸站下车C口出。</p>

        <p>【北京站 ➡ 鲨鱼公园乘车路线】</p>
        <p>乘坐地铁2号线到建国门站下车，换乘地铁1号线到国贸站下车C口出。</p>

        <p>【北京西站 ➡ 鲨鱼公园乘车路线】</p>
        <p>乘坐地铁9号线到军事博物馆站下车，换乘地铁1号线到国贸站下车C口出。</p>

        <p>【北京南站 ➡ 鲨鱼公园乘车路线】</p>
        <p>乘坐地铁4号线到西单站下车，换乘地铁1号线到国贸站下车C口出。</p>
      </div>
      <div class='img'><img src='../assets/img/abuout/2.jpg' alt=''></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// import Vue from 'vue'
import Header from '../components/Header'
import Footer from '../components/Footer'
// import BMap from 'BMap'
//
// Vue.use(BMap, {
//   ak: 'Xb4ghZ1AukGBB5RiXmHFlLou'
// })

export const BMAP_NORMAL_MAP = window.BMAP_NORMAL_MAP
export const BMAP_HYBRID_MAP = window.BMAP_HYBRID_MAP

export default {
  name: 'About',
  components: {Header, Footer},
  mounted: function () {
    this.map()
  },
  methods: {
    map: function () {
      // var map = new BMap.Map('allmap')
      // map.centerAndZoom(new BMap.Point(116.466203, 39.910723), 18)
      // map.addControl(new BMap.MapTypeControl({
      //   mapTypes: [
      //     BMAP_NORMAL_MAP,
      //     BMAP_HYBRID_MAP
      //   ]
      // }))
      // map.setCurrentCity('北京')
      // map.enableScrollWheelZoom(true)
      // console.log(map)
      // var pt = new BMap.Point(116.466203, 39.910723)
      // var myIcon = new BMap.Icon('http://lbsyun.baidu.com/jsdemo/img/fox.gif', new BMap.Size(300, 157))
      // var marker2 = new BMap.Marker(pt, {icon: myIcon})
      // map.addOverlay(marker2)
      // console.log(map)
      // console.log(111111111111)
      // console.log(marker2)
    }
  }
}
</script>
<style>
  .banner-about {
    width: 100%;
    height: auto;
  }

  .banner-about img {
    width: 100%;
  }

  .content {
    width: 100%;
    height: auto;
    margin: 0 auto;
    text-align: center;
  }

  .img {
    width: 100%;
    height: auto;
    margin: 0 auto;
    text-align: center;
  }

  .img img {
    width: 100%;
  }

  .map {
    width: 80%;
    height: 100%;
    margin: 0 auto;
    text-align: center;
    margin-top: 3em;
  }
</style>
